import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AttributeTranslations } from '../../product.types';
import { buildAttributeTransPath } from '../../utils/buildTranslationPaths';

type RawAttributeTranslations = {
  options: Record<string, RawOptionTranslations>;
};

type RawOptionTranslations = {
  selector: { valueProps: Record<string, string> };
};

export const useGetDeliveryOptionValuePropTranslations = (attributeId: string) => {
  const { t } = useTranslation('stationeryPriceConfigMapping');

  const attrTrans = t(buildAttributeTransPath(attributeId), { returnObjects: true }) as AttributeTranslations;

  const getDeliveryOptionValuePropTranslations = useCallback(
    (optionId: string): string[] => {
      const attribute = attrTrans as unknown as RawAttributeTranslations;

      if (!attribute.options) {
        return [];
      }

      const possibleOptions = Object.keys(attribute.options);

      if (!possibleOptions.includes(optionId)) {
        return [];
      }

      const option = attribute.options[optionId];
      const knownValuePropKeys = Object.keys(option.selector.valueProps);

      // const optionTrans = t[optionId];
      return knownValuePropKeys.map(key => {
        return option.selector.valueProps[key];
      });
    },
    [attrTrans],
  );

  return {
    getDeliveryOptionValuePropTranslations,
  };
};
